import { Price } from '@kunalabs-io/kai'

import { Button } from 'components/Button/Button'
import { Spinner } from 'components/Spinner/Spinner'
import { MAX_SLIDER } from './AmountSlider'
import { ReductionInfoSubmit } from '../../types'

interface Props {
  onWithdraw: (
    reductionInfo?: ReductionInfoSubmit,
    priceX?: Price<string, string>,
    priceY?: Price<string, string>
  ) => Promise<void>
  reductionInfoSubmit: ReductionInfoSubmit
  amountPercentage: number
  isLoading: boolean
  priceX?: Price<string, string>
  priceY?: Price<string, string>
}

export const DialogActions = ({
  onWithdraw,
  reductionInfoSubmit,
  amountPercentage,
  isLoading,
  priceX,
  priceY,
}: Props) => {
  return (
    <Button
      onClick={() => onWithdraw(reductionInfoSubmit, priceX, priceY)}
      style={{
        marginTop: 40,
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 49,
      }}
      disabled={amountPercentage === 0}
    >
      {isLoading ? (
        <Spinner style={{ marginTop: 0, marginLeft: 'inherit' }} />
      ) : amountPercentage === MAX_SLIDER ? (
        'Close position'
      ) : (
        'Withdraw'
      )}
    </Button>
  )
}
